import api from "../../services/api";

export const getExerciseCandidates = async (params) => {
  const response = await api.get("teacher/exams/exercises/candidates/", { params });
  const data = response.data || {};
  return {
    count: Number(data.count) || 0,
    page: Number(data.page) || 1,
    pageSize: Number(data.page_size) || 20,
    totalPages: Number(data.total_pages) || 0,
    results: Array.isArray(data.results) ? data.results : [],
  };
};

export const correlation = async (payload) => {
  const response = await api.post("teacher/exams/correlation/", payload);
  return response.data;
};

export const getExercisePreview = async (exerciseId) => {
  const response = await api.get(`teacher/exams/exercises/${exerciseId}/preview/`, {
    responseType: "blob",
  });
  return response.data;
};
